import {
  CreateMemberStatusChangeRequestDto,
  FilterGroupDto,
  MemberStatusDto,
  NewMemberStatusChangeRequestViewDto,
  PaginatedUsersDto,
  PatchMemberStatusChangeRequestViewDto,
  UpdateMemberStatusChangeRequestDto,
  UserDto,
  UserForGeoMapDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const membersRequests = {
  getMember: EndpointDefinition.get<UserDto, { id: string }>({
    name: 'getMember',
    route: '/users/:id',
    defaults: { params: { 'include-details': 'true' } },
  }),

  getMembersForMap: EndpointDefinition.get<
    UserForGeoMapDto[],
    {
      clientIds?: string;
      guideId?: string;
      segmentIds?: string;
      statusIds?: string;
      searchTerm?: string;
      includeStageAndStatus: boolean;
      forMap: boolean;
      readonly?: boolean;
    }
  >({
    name: 'getMembersForMap',
    route: '/users',
    defaults: { params: { readonly: true } },
  }),

  getPaginatedMembersForTable: EndpointDefinition.get<
    PaginatedUsersDto,
    {
      clientIds?: string;
      guideIds?: string | string[];
      segmentIds?: string;
      statusIds?: string;
      orderBy?: string;
      orderDirection?: string;
      searchTerm?: string;
      'page-start': number;
      'page-size': number;
      includeCount: boolean;
      includeDetails: boolean;
      readonly?: boolean;
    }
  >({
    name: 'getPaginatedMembersForTable',
    route: '/users',
    defaults: { params: { readonly: true } },
  }),

  getMemberFilters: EndpointDefinition.get<
    FilterGroupDto,
    {
      named?: string;
    }
  >({
    name: 'getMemberFilters',
    route: '/users/filters',
  }),

  getMemberStatuses: EndpointDefinition.get<MemberStatusDto[], null>({
    name: 'getMemberStatuses',
    route: '/users/member-statuses',
  }),

  postMemberStatusChangeRequest: EndpointDefinition.post<
    NewMemberStatusChangeRequestViewDto,
    CreateMemberStatusChangeRequestDto,
    null
  >({
    name: 'postMemberStatusChangeRequest',
    route: '/users/member-status-change-request',
  }),
  patchMemberStatusChangeRequest: EndpointDefinition.patch<
    PatchMemberStatusChangeRequestViewDto,
    UpdateMemberStatusChangeRequestDto,
    { id: number }
  >({
    name: 'postMemberStatusChangeRequest',
    route: '/users/member-status-change-request/:id',
  }),

  postMemberViewedEvent: EndpointDefinition.post<
    void,
    null,
    { memberId: string }
  >({
    name: 'memberViewedEvent',
    route: '/users/:memberId/viewed',
  }),

  dismissMemberStatusChange: EndpointDefinition.patch<
    null,
    null,
    { id: number }
  >({
    name: 'dismissMemberStatusChange',
    route: '/users/member-status-change/:id/dismiss',
  }),
};
